<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
  <path d="M21 12C21 7.038 16.962 3 12 3C7.037 3 3 7.037 3 12" stroke="#5C6E93" stroke-width="2.5"
    stroke-linecap="round" stroke-linejoin="round" />
  <path d="M12 21C16.963 21 21 16.962 21 12" stroke="#5C6E93" stroke-width="2.5" stroke-linecap="round"
    stroke-linejoin="round" />
  <path d="M3 12C3 16.963 7.037 21 12 21" stroke="#5C6E93" stroke-width="2.5" stroke-linecap="round"
    stroke-linejoin="round" />
  <path
    d="M15.3271 9.51953C15.1891 9.51953 15.0771 9.63153 15.0781 9.76953C15.0781 9.90753 15.1901 10.0195 15.3281 10.0195C15.4661 10.0195 15.5781 9.90753 15.5781 9.76953C15.5781 9.63153 15.4661 9.51953 15.3271 9.51953"
    stroke="#5C6E93" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" />
  <path
    d="M8.63963 9.5C8.50163 9.5 8.38963 9.612 8.39063 9.75C8.39063 9.888 8.50263 10 8.64063 10C8.77863 10 8.89063 9.888 8.89063 9.75C8.89063 9.612 8.77863 9.5 8.63963 9.5"
    stroke="#5C6E93" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" />
  <path d="M8.5 15.9995C8.5 15.9995 9.813 14.6875 12 14.6875C14.188 14.6875 15.5 15.9995 15.5 15.9995" stroke="#5C6E93"
    stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" />
</svg>